<template>
  <app-header-base>
    <div class="h-100 d-flex ai-center jc-end">
      <span class="h6 c-white">Call us for support 1-855-723-2266</span>
    </div>
  </app-header-base>
</template>

<script>
import AppHeaderBase from '@/layouts/components/AppHeaderBase';

export default {
  name: 'pro-desk-reporting-header',
  components: {
    AppHeaderBase,
  },
};
</script>
